import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PayDriver,
    PayShop,
    PaySupplier,
    PaymentRecieved,
    PaymentFastag,
    TransactionHistory,
    TransactionPending
 } from '../TopCard/icons';
 import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
 import ChevronRightIcon from "@material-ui/icons/ChevronRight";
 import { numberFormat,getDateInStringDDMMMYYYY,getVehicleNumberValuesDWeb } from '../../../utils/utils';
 import { getVehicleNumberValues } from '../../../store/actions/utils/utils';
const useStyles = makeStyles((theme) => ({
  paymentCard: {
      boxShadow:'none',
      borderRadius:8,
      marginTop:24
  },
  detailsDiv:{
      padding:16
  },
  detailsDiv1:{
      marginTop:24
  },
  successDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#00885a",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  pendingDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#ffa462",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  successIcon:{
      marginRight:16,
      color:"#fff"
  },
  pendingIcon:{
      marginRight:16,
      color:"#fff"
  },
  headerTxt:{
      fontSize:16,
      fontWeight:600,
      color:"#fff"
  },
  section:{
      marginBottom:16,
      display:'flex',
      flexDirection:'column',
      "&:last-child": {
        marginBottom: 0
      }
  },
  subTitleSec:{
      marginBottom:2,
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  valueSec:{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  subTitleTxt:{
      fontSize:12,
      fontWeight:500,
      color: "rgba(11, 19, 35, 0.5)"
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  },
  partyName:{
      color:"#0b1323",
      fontSize:16,
      marginBottom:8
  },
  route:{
      color:"#0b1323",
      fontSize:12,
      marginBottom:4,
      fontWeight:600
  },
  date:{
      color:"#0b1323",
      fontSize:12,
      //marginBottom:8
  },
  viewTrip:{
    color:"#0033cc",
    fontSize:16,
    fontWeight:600,
    cursor:"pointer"
  },
  arrow:{
    color:"#0033cc",  
  },
  dot:{
      color:'#c4c4c4',
      margin:"0px 4px",
      fontSize:4
  },
  loadBox:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      padding:'8px 0',
      marginTop:8,
      backgroundColor:'#f1f1f3',
      width:'100%',
      borderRadius:8,
      opacity:0.72,
      //cursor:'pointer'
  },
  moreLoads:{
    color:"#0b1323",
    fontSize:12,
    fontWeight:600,
  }
}));
const PaymentDetailsCard = (props) => {
  const { 
      title,
      type,
      data
    } = props;
  const classes = useStyles();
  let history = useHistory();
  const getPaymentStatus = (type)=>{
    switch (type) {
        case "SUCCESS":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Payment Successful</Typography>
                   </div>
        case "RELEASED":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Recharge Successful</Typography>
                   </div>
        case "REFUNDED":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Refund Successful</Typography>
                   </div>
        case "PENDING":
            return <div className={classes.pendingDiv}>
                    <TransactionPending className={classes.pendingIcon} />
                    <Typography className={classes.headerTxt}>Payment Pending</Typography>
                  </div>
        default:
            return ""
      }
  }
  const getSubTitle = (type)=>{
    switch (type) {
        case "vendor":
            return "Supplier Name";
        case "shop":
            return "Shop Name";
        case "driver":
            return "Driver Name";
        case "customer":
            return "Party Name";
        case "fastag":
            return "Vehicle Number";
        case "fuelcard":
            return "Vehicle Number";    
        default:
            return null
      }
  }
  const getSubPaymentType= (amount)=>{
    switch (amount) {
        case amount<0:
            return "Credit";
        case  amount>0:
            return "Payment";
        default:
            return null
      }
  }
  const getSubBankName = (type)=>{
    switch (type) {
        case "vendor":
            return "Supplier Bank";
        case "shop":
            return "Shop Bank";
        case "driver":
            return "Driver Bank";
        case "customer":
            return "Party Bank";
        case "fastag":
            return "Vehicle Number";
        case "fuelcard":
            return "Diesel Card";    
        default:
            return null
      }
  }
  const goToTripView = (data) => {
    if (data && data.tripId) {
      history.push({
        pathname: `/trips/view/${data.tripId}`,
        state: {
          id: 7,
          tripData: data,
          tripView: true,
          pageTitle: 'Trip Details',
          // pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
        }
      });
    }

  }
  const goVehicleView = (data) => {
    if (data && data.vehicleId) {
        let vnum = data&&data.vehicleNumber?data.vehicleNumber.replace(/\s/g, ''):"";
        let vehicleNumberPrefix="";
        let vehicleNumberSuffix="";
        let vehicleNumArray = getVehicleNumberValues(vnum)
        if(vehicleNumArray){
            vehicleNumberPrefix=vehicleNumArray[0]
            vehicleNumberSuffix=vehicleNumArray[1]
        }
        const status = data && data.status?data.status:"";
        const ownershipTypeValue =data && data.ownershipType?data.ownershipType:'';
        const bodyTypeValue = data && data.vehicleBodyType?data.vehicleBodyType:"";
        history.push({
            pathname: `/trucks/single-truck/${data.vehicleId}`,
            state: {
                id: 8,
                pageTitle: [vehicleNumberPrefix, vehicleNumberSuffix],
                vehicleId: data.vehicleId,
                ownershipType: ownershipTypeValue,
                bodyType: bodyTypeValue,
                vehicleStatus: status || null,
            }
      });
    }
  }
  const goToJourneyView = (data)=>{
    if (data && data.journeyId) {
        history.push({
          pathname: `/trips/view/${data.journeyId}`,
          state: {
            id: 7,
            tripData: data,
            tripView: true,
            pageTitle: 'Trip Details',
            // pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
          }
        });
    }
  }
  return (
    <>
      <Paper className={classes.paymentCard}>
            {data && data.entityType == 'shopPayment' && 
                <>
                    <div className={classes.detailsDiv}>
                       {data && data.tripId?<>
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                                <div>
                                    <Typography className={classes.partyName}>{data&&data.partyName?data.partyName:""}</Typography>
                                    <Typography className={classes.route}>{data&&data.startLocation?data.startLocation:""}-{data&&data.destinationLocation?data.destinationLocation:""}</Typography>
                                    <Typography className={classes.date}>
                                        {data&&data.tripStartDate?getDateInStringDDMMMYYYY(data.tripStartDate):''}
                                        {data&&data.vehicleNumber&&<>
                                            <FiberManualRecordIcon className={classes.dot} />
                                            {data.vehicleNumber}
                                        </>}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography onClick={(e)=>{goToJourneyView(data)}} className={classes.viewTrip}>View Trip <ChevronRightIcon className={classes.arrow}/></Typography>
                                </div>
                            </div>
                       </>:data && data.journeyId?<>
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                                <div>
                                    <Typography className={classes.partyName}>{data&&data.partyName?data.partyName:""}</Typography>
                                    <Typography className={classes.route}>{data&&data.startLocation?data.startLocation:""}-{data&&data.destinationLocation?data.destinationLocation:""}</Typography>
                                    <Typography className={classes.date}>
                                        {data&&data.tripStartDate?getDateInStringDDMMMYYYY(data.tripStartDate):''}
                                        {data&&data.vehicleNumber&&<>
                                            <FiberManualRecordIcon className={classes.dot} />
                                            {data.vehicleNumber}
                                        </>}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography onClick={(e)=>{goToJourneyView(data)}} className={classes.viewTrip}>View Trip <ChevronRightIcon className={classes.arrow}/></Typography>
                                </div>
                            </div>
                            {data&& data.loadCount && data.loadCount>1 && <div className={classes.loadBox}>
                                <Typography onClick={(e)=>{goToJourneyView(data)}} className={classes.moreLoads}>+{data.loadCount-1}&nbsp;more loads</Typography>
                            </div>}
                       </>:<>
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                                <div>
                                    <Typography className={classes.subTitleTxt}>Truck No</Typography>
                                    <Typography className={classes.route}>{data&&data.vehicleNumber?data.vehicleNumber:''}</Typography>
                                </div>
                                <div>
                                    <Typography onClick={(e)=>{goVehicleView(data)}} className={classes.viewTrip}>View Truck <ChevronRightIcon className={classes.arrow}/></Typography>
                                </div>
                            </div>
                       </>}
                    </div>
                </>
            }
      </Paper>
    </>
  );
}
export default PaymentDetailsCard;